import { AddIcon } from '@chakra-ui/icons';
import { Box, Button, ButtonGroup, Flex, IconButton, Input, Select, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { BsFillPeopleFill, BsFillTrashFill } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import SidebarWithHeader from '../../components/sidebar/sidebar';
import { getDeptVal, getInstVal } from '../../components/common/CommonFunctions';
import { ceil } from 'lodash';
import ToastMessage from '../../components/utility/ToastMessage';
import CustomSpinner from '../../components/utility/CustomSpinner';
import Space from '../../components/utility/Space';
import EvergreenPagination from '../../components/Pagination/EvergreenPagination';
import CommonModal from '../../components/common/CommonModal';

export default function HonsMastersStudents(){
    return <StudentList />;
}

const StudentList = () =>{
    const [users, setUsers] = useState([]);
    const [total, setTotal] = useState(0);
    const token = localStorage.getItem('my_token');
    const [isLoading, setIsLoading] = useState(false);
    const [batches, setBatches] = useState([]);
    const [halls, setHalls] = useState([]);
    const [dept_inst, setDeptInst] = useState([]);
    
    const limit = 20;
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [filterRegistrationNo, setFilterRegistrationNo] = useState('');
    const [filterName, setFilterName] = useState('');
    const [filterBatch, setFilterBatch] = useState('');
    const [filterHall, setFilterHall] = useState('');
    const [filterDeptInstitue, setFilterDeptInstitute] = useState('');
    const [filterHonsMasters, setFilterHonsMasters] = useState('');

    const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
    const [targetDeleteId, setTargetDeleteId] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        fetchStudents();
    }, [currentPage]);

    const fetchStudents = async () => {
        setIsLoading(true);
        const config = {
            headers: { Authorization: `Bearer ${token}` },
            params:{
                'fullname': filterName,
                'registration_no': filterRegistrationNo,
                'batch' : filterBatch,
                'hall' : filterHall,
                'department': getDeptVal(filterDeptInstitue),
                'institute': getInstVal(filterDeptInstitue),
                'hons_masters_option': filterHonsMasters,
                'limit': limit,
                'page': currentPage
            }
        };

        try {
            var apiResponse = (await axios.get(`${process.env.REACT_APP_API_URL}/api/get-hons-masters-students`, config)).data;
            if (apiResponse.error === false && apiResponse.results) {
                setUsers(apiResponse.results.users);
                setTotal(apiResponse.results.count);
                if (apiResponse.results.count) {
                    setTotalPages(ceil(apiResponse.results.count / limit));
                }
            }
        } catch (error) {
            ToastMessage('error', 'Something went wrong');
        }

        setIsLoading(false);
    };

    useEffect(() => {
        fetchBatches();
        fetchHalls();
        fetchDeptInstitutes();
    }, []);

    const config = {
        headers: { Authorization: `Bearer ${token}` },
    };

    const fetchBatches = async () => {
        try {
            var apiResponse = (await axios.get(`${process.env.REACT_APP_API_URL}/api/batches`,config)).data;
            if (apiResponse.error === false && apiResponse.results) {
                setBatches(apiResponse.results[0]);
            }
        } catch (error) {
            console.log({ error });
        }
    };

    const fetchHalls = async () => {
        try {
            var apiResponse = (await axios.get(`${process.env.REACT_APP_API_URL}/api/hall`)).data;
            if (apiResponse.error === false && apiResponse.results) {
                setHalls(apiResponse.results[0]);
            }
        } catch (error) {
            console.log({ error });
        }
    };

    const fetchDeptInstitutes = async () => {
        try {
            var apiResponse = (await axios.get(`${process.env.REACT_APP_API_URL}/api/get-dept-institutes`,config)).data;
            if (apiResponse.error === false && apiResponse.results) {
                setDeptInst(apiResponse.results);
            }
        } catch (error) {
            console.log({ error });
        }
    };

    const hons_or_masters_options = () => {
        let rtn_data = [];
        rtn_data.push(
            <option value={0}>HONS</option>
        );
        rtn_data.push(
            <option value={1}>MASTERS</option>
        );
        return rtn_data;
    }

    const getBatchOptions = () => {
        let return_data = [];

        if(batches.length > 0){
            for(let i=0;i<batches.length;i++){
                return_data.push(
                    <option key={i} value={batches[i].id}>{batches[i].batch}</option>
                )
            }
        }
        return return_data;
    }

    const getHallOptions = (halls) => {
        let return_data = [];

        if(halls.length > 0){
            for(let i=0;i<halls.length;i++){
                return_data.push(
                    <option key={i} value={halls[i].id}>{halls[i].hall}</option>
                )
            }
        }
        return return_data;
    }

    const getDeptInstOptions = (dept_inst) => {
        let return_data = [];

        if(dept_inst.length > 0){
            for(let i=0;i<dept_inst.length;i++){
                return_data.push(
                    <option key={i} value={dept_inst[i].id+'#'+dept_inst[i].type}>{dept_inst[i].name}</option>
                )
            }
        }
        return return_data;
    }

    const deleteData = (id) => {
        axios
            .delete(`${process.env.REACT_APP_API_URL}/api/delete-user/${id}`,config)
            .then((response) => {
                fetchStudents();
                ToastMessage("success","Deleted Successfully");
            })
            .catch((error) => {
                ToastMessage('error', 'Something went wrong');
            });
    }

    const onClickDelete = (id) => {
        setDisplayDeleteModal(true);
        setTargetDeleteId(id);
    }

    const DisplayData = () => {
        return (
            <Table
                variant="striped"
                color={'black'}
                display={{
                    base: 'block',
                    md: 'table',
                }}
                sx={{
                    '@media print': {
                    display: 'table',
                    },
                }}
            >
                <Thead
                    display={{
                    base: 'none',
                    md: 'table-header-group',
                    }}
                    sx={{
                    '@media print': {
                        display: 'table-header-group',
                    },
                    }}
                >
                    <Tr>
                        <Th textAlign={'center'}>Registration No</Th>
                        <Th textAlign={'center'}>Fullname</Th>
                        <Th textAlign={'center'}>Batch</Th>
                        <Th textAlign={'center'}>Hall</Th>
                        <Th textAlign={'center'}>Hons/Masters</Th>
                        <Th textAlign={'center'}>Dept/Inst</Th>
                        <Th textAlign={'center'}>Action</Th>
                    </Tr>
                </Thead>
                <Tbody
                    display={{
                    base: 'block',
                    lg: 'table-row-group',
                    }}
                    sx={{
                    '@media print': {
                        display: 'table-row-group',
                    },
                    }}
                >
                    {users.length > 0 &&
                        users.map((user, idx) => (
                            <Tr
                            key={idx}
                            display={{
                                base: 'grid',
                                md: 'table-row',
                            }}
                            sx={{
                                '@media print': {
                                display: 'table-row',
                                },
                                gridTemplateColumns: 'minmax(0px, 35%) minmax(0px, 65%)',
                                gridGap: '10px',
                            }}
                            >
                                <Td
                                    fontSize="md"
                                    fontWeight="hairline"
                                    textAlign={'center'}
                                >
                                    <Link className='link_details' to={'/user_details/'+user.id}>{user.registration_no}</Link>
                                </Td>
                                <Td
                                    fontSize="md"
                                    fontWeight="hairline"
                                    textAlign={'center'}
                                >
                                    {user.fullname}
                                </Td>
                                <Td
                                    fontSize="md"
                                    fontWeight="hairline"
                                    textAlign={'center'}
                                >
                                    {user.batch}
                                </Td>
                                <Td
                                    fontSize="md"
                                    fontWeight="hairline"
                                    textAlign={'center'}
                                >
                                    {user.hall}
                                </Td>
                                <Td
                                    fontSize="md"
                                    fontWeight="hairline"
                                    textAlign={'center'}
                                >
                                    {user.hons_or_masters == '0' ? 'Hons' : 'Masters'}
                                </Td>
                                <Td
                                    fontSize="md"
                                    fontWeight="hairline"
                                    textAlign={'center'}
                                >
                                    {user.dept_or_inst_name}
                                </Td>
                                <Td textAlign={'center'}>
                                <ButtonGroup variant="solid" size="sm" spacing={3}>
                                    {/* <IconButton
                                        colorScheme="green"
                                        aria-label="edit"
                                        icon={<AiFillEdit />}
                                        onClick={() => handleEdit(user.id)}
                                    /> */}
                                    <IconButton
                                        colorScheme="red"
                                        variant="outline"
                                        aria-label="delete"
                                        icon={<BsFillTrashFill />}
                                        onClick={() => onClickDelete(user.id)}
                                    />
                                </ButtonGroup>
                            </Td>
                            </Tr>
                        )
                        )
                    }
                </Tbody>
            </Table>
        )
    }

    const handleEdit = (id) => {
        //navigate('/edit-admin/'+id);
    }

    const handleSearch = () => {
        fetchStudents();
    }

    const handleClear = () => {
        setFilterName('');
        setFilterRegistrationNo('');
        setFilterBatch('');
        setFilterHall('');
        setFilterHonsMasters('');
        setFilterDeptInstitute('');
    }

    return (
        <>
            <Flex justifyContent={'center'} className="admin_title">
                <Text fontSize="xl">HONS AND MASTERS STUDENTS</Text>
            </Flex>

            <Space />

            { displayDeleteModal &&
                <CommonModal
                    reset={setDisplayDeleteModal}
                    setTargetDeleteId={setTargetDeleteId}
                    deleteAction={deleteData}
                    targetDeleteId={targetDeleteId}
                />
            }

            {/* Filter Box */}
            <Flex
                w={{ base: '95%', md: '95%', sm: 'full' }}
                m={'auto'}
                p={3}
                alignItems="center"
                justifyContent="center"
                border={'1px'}
                borderColor="gray.300"
                backgroundColor="#ffffff"
                borderRadius={'lg'}
                className="admin_table"
                direction="column"
            >

                <Flex className='search_items' gap="4">
                    <Input placeholder='Registration No' size='md' value={filterRegistrationNo} onChange={(e) => setFilterRegistrationNo(e.target.value)} />
                    <Input placeholder='Name' size='md' value={filterName} onChange={(e) => setFilterName(e.target.value)} />
                    <Select placeholder='Select Batch' size='md' value={filterBatch} onChange={(e) => setFilterBatch(e.target.value)}>
                        {getBatchOptions()}
                    </Select>
                    <Select placeholder='Select Hall' size='md' value={filterHall} onChange={(e) => setFilterHall(e.target.value)}>
                        {getHallOptions(halls)}
                    </Select>
                    <Select placeholder='Select Hons/Masters' size='md' value={filterHonsMasters} onChange={(e) => setFilterHonsMasters(e.target.value)}>
                        {hons_or_masters_options()}
                    </Select>
                    <Select placeholder='Select Dept/Inst' size='md' value={filterDeptInstitue} onChange={(e) => setFilterDeptInstitute(e.target.value)}>
                        {getDeptInstOptions(dept_inst)}
                    </Select>
                </Flex>
                <Flex mt={'10px'} direction='row' gap='4'>
                    <Button colorScheme='teal' variant='outline' size='sm' onClick={handleSearch}>
                        Search
                    </Button>
                    <Button colorScheme='red' variant='outline' size='sm' onClick={handleClear}>
                        Clear
                    </Button>
                </Flex>
            </Flex>

            <Space />

            <Flex
                w={{ base: '95%', md: '95%', sm: 'full' }}
                m={'auto'}
                p={3}
                alignItems="center"
                justifyContent="center"
                border={'1px'}
                borderColor="gray.300"
                borderRadius={'lg'}
                className="admin_table"
            >
                {isLoading
                    ? <CustomSpinner />
                    : <DisplayData />
                }
            </Flex>

            <EvergreenPagination
                currentPage={currentPage}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
            />
        </>
    )
}
